var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"signup-success","data-test":"signup-success"}},[_c('div',{staticClass:"col-md-6"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }